import { Sparkles, Award, Users } from "lucide-react";
import { Reveal, scrollToId } from "./Reveal";

const PROMISES = [
  {
    Icon: Sparkles,
    title: "Real, hands-on mastery",
    desc:
      "No fluff, no theory-only lectures. You'll braid, refine, and repeat under expert guidance until the technique lives in your hands.",
  },
  {
    Icon: Award,
    title: "Certification that opens doors",
    desc:
      "Graduate as a Crowned™ Pro with a credential — and a portfolio — that tells clients you trained at the highest standard.",
  },
  {
    Icon: Users,
    title: "A sisterhood that lasts",
    desc:
      "Join the founding cohort and step into a lifetime community of braiders who grow, refer, and rise together.",
  },
];

export const Testimonials = () => (
  <section data-testid="promise-section" className="bg-cream py-24 sm:py-32">
    <div className="max-w-[1400px] mx-auto px-6">
      <Reveal className="max-w-2xl mb-16">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-wine/50">
          The Founding Cohort
        </span>
        <h2 className="font-display font-light text-wine text-5xl sm:text-6xl leading-[1] mt-5">
          Be among the first to be <span className="italic text-gold">Crowned.</span>
        </h2>
        <p className="text-wine/70 mt-6 text-lg leading-relaxed">
          Crowned™ Pro — Level 1 launches September 15, 2026. This is the very first class, which
          means your seat comes with rare access, personal attention, and a place in the story from
          day one. Here's what every founding student can count on.
        </p>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-6">
        {PROMISES.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1} testId={`promise-${i}`}>
            <div className="h-full flex flex-col rounded-3xl bg-white border border-wine/10 p-8 hover:shadow-xl hover:shadow-wine/5 transition-shadow duration-500">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-wine mb-6">
                <p.Icon className="h-5 w-5 text-gold" />
              </span>
              <h3 className="font-display text-3xl text-wine leading-tight">{p.title}</h3>
              <p className="text-wine/60 mt-3 leading-relaxed flex-1">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-14">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 rounded-3xl bg-wine p-8 sm:p-10">
          <div>
            <div className="font-display text-3xl sm:text-4xl text-cream">
              Only 5 seats in the first cohort.
            </div>
            <p className="text-cream/60 mt-2">Early-crown pricing ends September 8.</p>
          </div>
          <button
            data-testid="promise-cta"
            onClick={() => scrollToId("enroll")}
            className="shrink-0 rounded-full bg-gold px-8 py-4 font-mono text-[12px] uppercase tracking-[0.18em] text-wine-deep hover:bg-cream transition-colors duration-300"
          >
            Reserve My Seat
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
